import React, { useCallback, useEffect, useState } from "react";
import { NotificationCard, Skeleton } from "@/components";
import { useSelector } from "react-redux";
import { selectAllNotifications } from "../../app/slices";

const NotificationSideBar = () => {
  const [notifications, setNotifications] = useState([]);
  const notificationsData = useSelector(selectAllNotifications);
  const { loading: notificationLoading } = useSelector(
    (state) => state.notification
  );

  const formatDate = useCallback(
    (dateString) =>
      new Date(dateString).toLocaleString("en-IN", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
    []
  );

  useEffect(() => {
    if (notificationsData.length > 0) {
      setNotifications(
        notificationsData.map((notif) => ({
          id: notif._id,
          image: notif.content?.imageUrl || "",
          title: notif.content?.title || "No Title",
          date: formatDate(notif.createdAt),
          description: notif.content?.message || "No Description",
        }))
      );
    }
  }, [notificationsData]);

  const NotificationSkeleton = () => (
    <div className="flex items-center space-x-4 bg-background rounded-xl p-3">
      <Skeleton className="h-12 w-12 rounded-xl bg-background_2/90" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-[150px] bg-background_2/90" />
        <Skeleton className="h-4 w-[100px] bg-background_2/90" />
      </div>
    </div>
  );

  return (
    <div className="flex flex-col gap-4">
      {notificationLoading ? (
        <>
          <NotificationSkeleton />
          <NotificationSkeleton />
          <NotificationSkeleton />
        </>
      ) : notifications.length > 0 ? (
        notifications.map((notification) => (
          <NotificationCard
            key={notification.id}
            image={notification.image}
            title={notification.title}
            date={notification.date}
            description={notification.description}
          />
        ))
      ) : (
        <p className="text-center text-gray-500">No notifications available</p>
      )}
    </div>
  );
};

export default NotificationSideBar;
